import { render, staticRenderFns } from "./InsufficientPointsModal.vue?vue&type=template&id=558ff88d"
import script from "./InsufficientPointsModal.vue?vue&type=script&lang=js"
export * from "./InsufficientPointsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports